export default __webpack_public_path__ + "static/media/Bed_Icon.d8b98342.svg";